var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.11538 15.5H10.5V10.5H15.5V2.11537C15.5 1.93589 15.4423 1.78846 15.3269 1.67307C15.2115 1.55769 15.0641 1.5 14.8846 1.5H2.11538C1.93589 1.5 1.78846 1.55769 1.67308 1.67307C1.55769 1.78846 1.5 1.93589 1.5 2.11537V14.8846C1.5 15.0641 1.55769 15.2115 1.67308 15.3269C1.78846 15.4423 1.93589 15.5 2.11538 15.5ZM2.11538 16.5C1.66794 16.5 1.28685 16.3426 0.9721 16.0279C0.657367 15.7131 0.5 15.3321 0.5 14.8846V2.11537C0.5 1.66794 0.657367 1.28685 0.9721 0.972099C1.28685 0.657366 1.66794 0.5 2.11538 0.5H14.8846C15.3321 0.5 15.7132 0.657366 16.0279 0.972099C16.3426 1.28685 16.5 1.66794 16.5 2.11537V10.7885L10.7885 16.5H2.11538ZM4.3846 9.96155V8.96152H8.5V9.96155H4.3846ZM4.3846 6V5H12.6154V6H4.3846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/icon-note.a9cfdad230fcab92f91f37baf7e1c241.svg";
export { ForwardRef as ReactComponent };